/* tslint:disable */
/* eslint-disable */
/**
 * Bias Proof License API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestConfigurationDTO
 */
export interface TestConfigurationDTO {
    /**
     * 
     * @type {string}
     * @memberof TestConfigurationDTO
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof TestConfigurationDTO
     */
    id?: string;
}

export function TestConfigurationDTOFromJSON(json: any): TestConfigurationDTO {
    return TestConfigurationDTOFromJSONTyped(json, false);
}

export function TestConfigurationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestConfigurationDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function TestConfigurationDTOToJSON(value?: TestConfigurationDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categoryId': value.categoryId,
        'id': value.id,
    };
}


